import React from 'react'
import styles from './groups.styles'
import injectSheet from 'react-jss'
import Group from './group/group.container'

const Groups = ({ classes, groups, onRemove, pupilId }) => (
  <div>
    {!groups.length && (
      <div className={classes.noGroups}>
        This pupil is not a member of any group yet
      </div>
    )}
    {groups.map(id => (
      <Group pupilId={pupilId} id={id} key={id} className={classes.group} />
    ))}
  </div>
)

export default injectSheet(styles)(Groups)
